<template>
  <div class="perfil-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="header-inner">
        <h1 class="header-title">Meu Perfil</h1>
        <p class="header-sub">Gerencie as suas informações pessoais e preferências</p>
      </div>
    </div>

    <div class="page-body">
      <div class="content-col">
        <!-- Profile Card -->
        <div class="profile-card">
          <div class="avatar-section">
            <div class="avatar-wrap">
              <q-avatar size="88px" class="user-avatar">
                <img v-if="user.photo" :src="user.photo" alt="Foto de perfil" />
                <q-icon v-else name="person" size="42px" />
              </q-avatar>
              <div class="verified-dot">
                <q-icon name="verified" size="13px" />
              </div>
            </div>
            <div class="avatar-info">
              <div class="user-name">{{ user.name }}</div>
              <div class="user-email">{{ user.email }}</div>
              <span class="role-pill">
                {{ store.state.auth.user?.role === 1 ? 'Administrador' : 'Agente' }}
              </span>
            </div>
          </div>

          <div class="card-divider"></div>

          <div class="actions-list">
            <button class="action-row" @click="navegarPara('update-profile')">
              <div class="action-icon-wrap blue">
                <q-icon name="manage_accounts" size="20px" />
              </div>
              <div class="action-text">
                <div class="action-label">Atualizar Informações</div>
                <div class="action-caption">Edite nome, contacto e foto de perfil</div>
              </div>
              <q-icon name="chevron_right" size="20px" class="action-arrow" />
            </button>

            <button class="action-row" @click="navegarPara('ChangePassword')">
              <div class="action-icon-wrap amber">
                <q-icon name="lock_reset" size="20px" />
              </div>
              <div class="action-text">
                <div class="action-label">Alterar Senha</div>
                <div class="action-caption">Atualize a sua senha de acesso</div>
              </div>
              <q-icon name="chevron_right" size="20px" class="action-arrow" />
            </button>

            <button class="action-row logout-row" @click="fazerLogout">
              <div class="action-icon-wrap red">
                <q-icon name="logout" size="20px" />
              </div>
              <div class="action-text">
                <div class="action-label logout-label">Terminar Sessão</div>
                <div class="action-caption">Encerrar a sessão actual</div>
              </div>
              <q-icon name="chevron_right" size="20px" class="action-arrow" />
            </button>
          </div>
        </div>

        <!-- Meta -->
        <div class="meta-card">
          <q-icon name="calendar_today" size="17px" class="meta-icon" />
          <div class="meta-text">
            <span class="meta-label">Membro desde</span>
            <span class="meta-value">{{ user.created_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/vuex/store';
import Swal from 'sweetalert2';

const router = useRouter();
const user = ref({ name: '', email: '', created_at: '', photo: '' });

const navegarPara = (rota) => {
  router.push({ name: rota });
};

onMounted(() => {
  user.value = store.state.auth.user ?? { name: '', email: '', created_at: '' };
});

watch(
  () => store.state.auth.user,
  (novoUsuario) => { if (novoUsuario) user.value = novoUsuario; }
);

const fazerLogout = async () => {
  const result = await Swal.fire({
    title: 'Terminar Sessão?',
    text: 'Tem certeza que deseja sair da sua conta?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sair',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#0d1b2a',
    reverseButtons: true
  });
  if (result.isConfirmed) {
    router.push('/');
  }
};
</script>

<style scoped>
.perfil-page {
  min-height: 100vh;
  background: #f4f6fb;
}

/* ── Header ── */
.page-header {
  background: #0d1b2a;
  padding: 32px 24px 28px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.15);
}
.header-inner { max-width: 560px; margin: 0 auto; }
.header-title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 4px;
}
.header-sub {
  font-size: 13px;
  color: rgba(212, 175, 55, 0.7);
  margin: 0;
  letter-spacing: 0.3px;
}

/* ── Body ── */
.page-body {
  display: flex;
  justify-content: center;
  padding: 28px 16px 48px;
}
.content-col { width: 100%; max-width: 540px; }

/* ── Profile Card ── */
.profile-card {
  background: #ffffff;
  border: 1px solid #e8ecf4;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(13, 27, 42, 0.07);
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 24px 22px;
}
.avatar-wrap { position: relative; flex-shrink: 0; }
.user-avatar {
  background: rgba(212, 175, 55, 0.12);
  color: #d4af37;
  border: 3px solid rgba(212, 175, 55, 0.28);
  border-radius: 50%;
}
.verified-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #16a34a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}
.user-name {
  font-size: 18px;
  font-weight: 700;
  color: #0d1b2a;
  margin-bottom: 3px;
}
.user-email {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}
.role-pill {
  display: inline-block;
  background: rgba(212, 175, 55, 0.12);
  color: #9a7c1e;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid rgba(212, 175, 55, 0.25);
}

.card-divider { height: 1px; background: #f0f2f7; margin: 0 24px; }

/* ── Actions ── */
.actions-list { padding: 6px 0 6px; }
.action-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 14px;
  padding: 14px 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.15s;
  text-align: left;
}
.action-row:hover { background: #f7f8fc; }
.logout-row:hover { background: rgba(220, 38, 38, 0.04); }

.action-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.action-icon-wrap.blue  { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
.action-icon-wrap.amber { background: rgba(245, 158, 11, 0.1); color: #d97706; }
.action-icon-wrap.red   { background: rgba(220, 38, 38, 0.08); color: #dc2626; }

.action-text { flex: 1; }
.action-label {
  font-size: 14px;
  font-weight: 600;
  color: #0d1b2a;
  line-height: 1.3;
}
.logout-label { color: #dc2626; }
.action-caption { font-size: 12px; color: #9ca3af; margin-top: 1px; }
.action-arrow { color: #d1d5db; flex-shrink: 0; }

/* ── Meta ── */
.meta-card {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
  background: #ffffff;
  border: 1px solid #e8ecf4;
  border-radius: 14px;
  padding: 14px 20px;
}
.meta-icon { color: #d4af37; flex-shrink: 0; }
.meta-text { display: flex; flex-direction: column; gap: 1px; }
.meta-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
}
.meta-value { font-size: 14px; color: #0d1b2a; font-weight: 600; }
</style>
